// extracted by mini-css-extract-plugin
export default {"list":"click-and-collect-view-tabs_list__8bec2","button":"click-and-collect-view-tabs_button__a72cc","selectedButton":"click-and-collect-view-tabs_selectedButton__27efb"};